import { Maybe, nothing } from 'maybeasy';
import { createContext } from 'react';
import { ProgramModuleProgressResource } from '../Types';

export const ProgramModuleProgressContext =
  createContext<Maybe<ProgramModuleProgressResource>>(nothing());
